// extracted by mini-css-extract-plugin
export default {"spinner":"Loader_spinner__Wzk20","wrapper":"Loader_wrapper__IL0BR"};